var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.1709C16.1173 14.1709 15.0371 13.9241 14.0409 13.4372C13.8848 13.3624 13.7036 13.3506 13.5382 13.407C13.3729 13.4647 13.2377 13.5855 13.1616 13.7417L12.6891 14.7195C11.2716 13.9057 10.0956 12.7284 9.2805 11.3109L10.2596 10.8384C10.4171 10.7623 10.5366 10.6271 10.5943 10.4618C10.6507 10.2964 10.6403 10.1153 10.5641 9.95906C10.0759 8.96419 9.82913 7.884 9.82913 6.75C9.82913 6.38775 9.53513 6.09375 9.17288 6.09375H6.75C6.38775 6.09375 6.09375 6.38775 6.09375 6.75C6.09375 12.9017 11.0983 17.9062 17.25 17.9062C17.6123 17.9062 17.9062 17.6123 17.9062 17.25V14.8271C17.9062 14.4649 17.6123 14.1709 17.25 14.1709Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.f1d4af19f4d1df074a424cb189f83c62.svg";
export { ForwardRef as ReactComponent };